// extracted by mini-css-extract-plugin
export default {"productDescription":"Tca-z","featuredDescription":"Uca-z","description":"Vca-z","more":"Wca-z","descriptionSku":"Xca-z"};